import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { UseOutletContextPlan } from './Plan';
import AppPreloader from '../../../../components/Preloader';

const LAST_ACCOUNT_STORAGE_KEY = 'da_last_plan_view_account';

export const saveLastPlanViewAccount = (companyId: string, accountId: string) => {
  if (!companyId || !accountId) return;
  try {
    const store = JSON.parse(localStorage.getItem(LAST_ACCOUNT_STORAGE_KEY) ?? '{}');
    store[companyId] = accountId;
    localStorage.setItem(LAST_ACCOUNT_STORAGE_KEY, JSON.stringify(store));
  } catch { /* localStorage unavailable */ }
};

export const getLastPlanViewAccount = (companyId: string): string | null => {
  try {
    const store = JSON.parse(localStorage.getItem(LAST_ACCOUNT_STORAGE_KEY) ?? '{}');
    return store[companyId] || null;
  } catch {
    return null;
  }
};

export interface PlanAccountRedirectPageProps {};

const PlanAccountRedirectPage: React.FunctionComponent<PlanAccountRedirectPageProps> = () => {
  const navigate = useNavigate();
  const { companyForUser, accountingAccountsForCompany } = UseOutletContextPlan();

  useEffect(() => {
    if (!companyForUser || !accountingAccountsForCompany) return;

    const lastAccountId = getLastPlanViewAccount(companyForUser.id);
    if (lastAccountId && accountingAccountsForCompany.some(a => a.id === lastAccountId)) {
      navigate(`/main/accounting/plan/view/${lastAccountId}`, { replace: true });
      return;
    }

    if (accountingAccountsForCompany.length > 0) {
      navigate(`/main/accounting/plan/view/${accountingAccountsForCompany[0].id}`, { replace: true });
      return;
    }

    navigate('/main/accounting/plan/list', { replace: true });
  }, [companyForUser, accountingAccountsForCompany, navigate]);

  return <AppPreloader />;
};

export default PlanAccountRedirectPage;
